import { render, staticRenderFns } from "./EditEmployee.vue?vue&type=template&id=2781307c&scoped=true&"
import script from "./EditEmployee.vue?vue&type=script&lang=js&"
export * from "./EditEmployee.vue?vue&type=script&lang=js&"
import style0 from "./EditEmployee.vue?vue&type=style&index=0&id=2781307c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2781307c",
  null
  
)

export default component.exports